/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const FacebookCircleLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M13 19.94a8 8 0 1 0-2 0V14H9v-2h2v-1.65c0-1.34.14-1.83.4-2.32q.4-.73 1.14-1.13c.38-.2.85-.33 1.68-.38q.5-.03 1.28.08v1.9H15c-.92 0-1.3.04-1.52.16a1 1 0 0 0-.31.32c-.13.22-.17.45-.17 1.37V12h2.5l-.5 2h-2zM12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20" />
  </Icon>
);
